<template>
  <BaseListItem :dense="dense">
    <router-link
      :to="{
        name: 'profile',
        params: { username: username }
      }"
    >
      <BaseListItemAvatar :size="avatarSize">
        <BaseImage
          :src="
            avatarPicture
              ? avatarPicture
              : require('@/assets/defaultProfilePicture.svg')
          "
          cover
        ></BaseImage>
      </BaseListItemAvatar>
    </router-link>
    <BaseListItemContent>
      <router-link
        :to="{
          name: 'profile',
          params: { username: username }
        }"
      >
        <BaseListItemTitle
          v-bind:class="{
            'text-body-1 font-weight-medium': !dense,
            'text-subtitle-2 font-weight-regular': dense
          }"
        >
          {{ username }}
        </BaseListItemTitle>
      </router-link>
      <BaseListItemSubtitle
        v-if="season"
        class="text-caption font-weight-regular text--secondary"
      >
        {{ $t(`core.seasons.${season}`) }}
      </BaseListItemSubtitle>
    </BaseListItemContent>
    <div class="d-flex justify-center align-center">
      <BaseButton
        v-if="postIsEditable"
        @click="$emit('manage-post')"
        :icon="true"
        :border="false"
        class="align-self-end"
      >
        <BaseIcon class="primary--text">more_vert</BaseIcon>
      </BaseButton>
    </div>
  </BaseListItem>
</template>

<script>
export default {
  name: "TheExperienceCardHeader",
  // DATAs
  props: {
    avatarSize: {
      type: Number,
      default: () => 40
    },
    dense: {
      type: Boolean,
      defaut: false
    },
    username: {
      type: String,
      required: true
    },
    avatarPicture: {
      type: String
    },
    season: {
      type: String
    },
    postIsEditable: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>
